import { JSX, useContext } from "react";

import MenuItemEnum from "@app/layout/menus/menuItemEnum";
import { UserContext } from "@app/user/UserContext";
import MegaMenuHeader from "@app/layout/menus/MegaMenuHeader";
import MegaMenuLink from "@app/layout/menus/MegaMenuLink";
import MegaMenuStandardLink from "@app/layout/menus/MegaMenuStandardLink";

//NOTE: Once a page is moved from 1.0 to 2.0, the MegaMenuStandardLink should be replaced with MegaMenuLink to prevent an unnecessary re-rendering of the whole page
export default function DownloadsMenu(): JSX.Element {
  const user = useContext(UserContext);

  return (
    <ul className="menu">
      <li>
        <MegaMenuHeader title="Downloads" />
        <ul className="menu">
          <MegaMenuLink menuItem={MenuItemEnum.Reports} faIcon="download" to="/reports" linkText="Reports" />
          {(user.canDownload || null) && (
            <>
              <MegaMenuStandardLink menuItem={MenuItemEnum.Software} faIcon="save" to={`${window.uiEndpoint}/Support/Software`} linkText="Software" />
              <MegaMenuStandardLink menuItem={MenuItemEnum.Data} faIcon="file-archive-o" to={`${window.uiEndpoint}/Support/Data`} linkText="Data" />
            </>
          )}
        </ul>
      </li>
    </ul>
  );
}
